<template>
  <v-tabs color="grey" background-color="grey lighten-4">
    <v-tabs-slider />
    <v-tab class="text-none grey--text">
      {{ $t('PROFILE.ADDITIONAL_INFO') }}
    </v-tab>

    <v-tab class="text-none grey--text">
      {{ $t('EREPORTER.NAME') }}
    </v-tab>
    <v-tab class="text-none grey--text">
      {{ $t('PERSONS.BILLING') }}
    </v-tab>
    <v-tab class="text-none grey--text">
      {{ $t('COMPANIES.IMAGE') }}
    </v-tab>

    <v-tab-item>
      <additional-info-form
        v-model="form"
        :readonly="readonly"
        :errors="errors"
        @input="emitter"
        @update-prop="updateProp(...arguments)"
      />
    </v-tab-item>
    <v-tab-item
      ><ereporter-form
        v-model="form"
        :readonly="readonly"
        :errors="errors"
        @input="emitter"
        @update-prop="updateProp(...arguments)"
    /></v-tab-item>
    <v-tab-item>
      <billing-form
        v-model="form"
        :readonly="readonly"
        :errors="errors"
        @input="emitter"
        @update-prop="updateProp(...arguments)"
      />
    </v-tab-item>
    <v-tab-item>
      <company-image-form
        v-model="form"
        :readonly="readonly"
        :errors="errors"
        @input="emitter"
        @update-prop="updateProp(...arguments)"
        @removeFile="$emit('removeFile', $event)"
      />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import AdditionalInfoForm from '@/modules/companies/components/Company/AdditionalInfoForm';
import formEditable from '@/modules/_global/mixins/form-editable';
import EreporterForm from '@/modules/companies/components/Company/EreporterForm';
import BillingForm from '@/modules/companies/components/Company/BillingForm';
import CompanyImageForm from '@/modules/companies/components/Company/CompanyImageForm';

export default {
  name: 'CompanyTabsForm',

  components: {
    CompanyImageForm,
    BillingForm,
    EreporterForm,
    AdditionalInfoForm
  },

  mixins: [formEditable]
};
</script>

<style scoped></style>
